import React from 'react';
import Verify from '../Verify/Verify.jsx';

export default () => (
  <Verify
    isResetPassword
  />
);
